import { FiltersMobileDrawer } from '../mobile/FiltersMobileDrawer';
import React from 'react';
import { dispatch, useSelector } from '@state/store';
import { FiltersSideBarContainer } from './FiltersSideBarContainer';
import {
  getDealFinderResultsData,
  getHasAppliedFilters
} from '@state/slices/deal-finder-results/dealFinderResultsSelectors';
import { setFilters } from '@state/slices/deal-finder-results/dealFinderResultsSlice';

export interface FiltersMobileDrawerContainerProps {
  onClose: () => void;
  open: boolean;
}

export const FiltersMobileDrawerContainer = (props: FiltersMobileDrawerContainerProps) => {
  const handleOnReset = () => dispatch(setFilters({}));
  const hasAppliedFilters: boolean = useSelector(getHasAppliedFilters);
  const {
    facets: {
      counts: { filtered }
    }
  } = useSelector(getDealFinderResultsData);
  return (
    <FiltersMobileDrawer
      {...props}
      hasAppliedFilters={hasAppliedFilters}
      onReset={handleOnReset}
      count={filtered}
      renderFilters={(props: any) => <FiltersSideBarContainer {...props} />}
    />
  );
};
